import { get } from "lodash";
import { findPartInstanceForKey } from "./find-part-instance-for-key";
import type { CarSetup, ChassisAssembly } from "./generated/graphql";
import type { DeepPartial } from "./utils";

export const getValueFromPart = (
  fieldKey: string,
  carSetup: DeepPartial<CarSetup> | null | undefined,
): string | undefined => {
  if (!carSetup?.chassisAssembly) {
    return "No Assembly";
  }
  const chassisAssembly = carSetup.chassisAssembly as ChassisAssembly;
  const keySplit = fieldKey.split(".");
  const fieldName = keySplit[keySplit.length - 1];
  const partInstance = findPartInstanceForKey(keySplit, chassisAssembly);

  if (!partInstance) {
    return `Part instance not found, spec: ${keySplit[2]} location: ${keySplit[keySplit.length - 2]}`;
  }
  const fieldNameToDisplay = fieldName === "select" ? "reference" : fieldName;

  return get(partInstance, `part.${fieldNameToDisplay}`);
};
